import React from "react";
import pluralize from "pluralize";
import { bool, func, number, string } from "prop-types";

import * as S from "./styled";

const RatingIcon = ({ marked, name, ratingIconId, updateRating, value }) => {
  const handleChange = () => updateRating(value);
  const labelText = pluralize("Rating Icon", value, true);

  return (
    <>
      <S.Input
        checked={marked}
        id={ratingIconId}
        name={name}
        onChange={handleChange}
        type="radio"
        value={value}
      />
      <S.Label htmlFor={ratingIconId}>
        <S.Span>{labelText}</S.Span>
      </S.Label>
    </>
  );
};

RatingIcon.propTypes = {
  marked: bool.isRequired,
  name: string.isRequired,
  value: number.isRequired,
  updateRating: func.isRequired,
  ratingIconId: string.isRequired
};

export default RatingIcon;
